// A device's platform availability, in the words the dashboards' connectivity widget uses; shared
// by the device table and the Import Devices dialog.
export const statusLabels = {
  AVAILABLE: { label: "Connected", color: "#4caf50" },
  UNAVAILABLE: { label: "Disconnected", color: "#555555" },
};
// a device the platform does not watch for availability has no status yet
export const statusOf = (status) =>
  statusLabels[status] || { label: status || "Never connected", color: "#BA75D8" };
// the status filter: a status, or NEVER for a device with no status record
export const statusFilters = [
  { value: "", label: "All statuses" },
  { value: "AVAILABLE", label: "Connected" },
  { value: "UNAVAILABLE", label: "Disconnected" },
  { value: "NEVER", label: "Never connected" },
];
